
/* SERVICE */
export const GET_SERVICE_LISTING = "GET_SERVICE_LISTING";
export const GET_SERVICE_LISTING_SUCCESS = "GET_SERVICE_LISTING_SUCCESS";
export const GET_SERVICE_LISTING_FAIL = "GET_SERVICE_LISTING_FAIL";

export const GET_SERVICE_DETAILS = "GET_SERVICE_DETAILS";
export const GET_SERVICE_DETAILS_SUCCESS = "GET_SERVICE_DETAILS_SUCCESS";
export const GET_SERVICE_DETAILS_FAIL = "GET_SERVICE_DETAILS_FAIL";

export const ADD_SERVICE = "ADD_SERVICE";
export const ADD_SERVICE_SUCCESS = "ADD_SERVICE_SUCCESS";
export const ADD_SERVICE_FAIL = "ADD_SERVICE_FAIL";

export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const UPDATE_SERVICE_SUCCESS = "UPDATE_SERVICE_SUCCESS";
export const UPDATE_SERVICE_FAIL = "UPDATE_SERVICE_FAIL";

export const DELETE_SERVICE = "DELETE_SERVICE";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAIL = "DELETE_SERVICE_FAIL";

export const EXPORT_SERVICE = "EXPORT_SERVICE";
export const EXPORT_SERVICE_SUCCESS = "EXPORT_SERVICE_SUCCESS";
export const EXPORT_SERVICE_FAIL = "EXPORT_SERVICE_FAIL";

export const RESET_SERVICE_STATE = 'RESET_SERVICE_STATE';
export const RESET_SERVICE_ATTACHMENT_STATE = 'RESET_SERVICE_ATTACHMENT_STATE';